/* tslint:disable */
/* eslint-disable */
/**
 * back-office-service
 * Back Office Service
 *
 * The version of the OpenAPI document: 0.29.35
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * The lottery's branding, shown by client apps
 * @export
 * @interface CustomerBranding
 */
export interface CustomerBranding {
    /**
     * The lottery's logo image URL. Null when none is set.
     * @type {string}
     * @memberof CustomerBranding
     */
    logoUrl: string | null;
}

/**
 * Check if a given object implements the CustomerBranding interface.
 */
export function instanceOfCustomerBranding(value: object): value is CustomerBranding {
    if (!('logoUrl' in value) || value['logoUrl'] === undefined) return false;
    return true;
}

export function CustomerBrandingFromJSON(json: any): CustomerBranding {
    return CustomerBrandingFromJSONTyped(json, false);
}

export function CustomerBrandingFromJSONTyped(json: any, ignoreDiscriminator: boolean): CustomerBranding {
    if (json == null) {
        return json;
    }
    return {
        
        'logoUrl': json['logoUrl'],
    };
}

export function CustomerBrandingToJSON(value?: CustomerBranding | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'logoUrl': value['logoUrl'],
    };
}

